import { render } from "./ItemsPerPage.vue?vue&type=template&id=17275358"
import script from "./ItemsPerPage.vue?vue&type=script&lang=js"
export * from "./ItemsPerPage.vue?vue&type=script&lang=js"

import "./ItemsPerPage.vue?vue&type=style&index=0&id=17275358&lang=scss"

import exportComponent from "/builds/flowberry1/flowberry/user-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSelect});
